class Tabs {
	constructor() {
		this.selectors = {
			document: document,
			promo_Tab: '.promo_block_tabs_item',
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {

		// Initializing Slider for Promo Tabs

		this.nodes.promo_Tab.each(function (){
			$(this).find('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
				var tab_pane = $(e.target).attr('href');
				if ($(tab_pane).find('.slickSlider') && $('.slickSlider').length > 0 ){
					$(tab_pane).find('.slickSlider').slick('setPosition');
				}
				if ($(tab_pane).find('.slickSliderWithBanner') && $('.slickSliderWithBanner').length > 0 ){
					$(tab_pane).find('.slickSliderWithBanner').slick('setPosition');
				}
			})
		});

	}
}
new Tabs();